import React, { Component } from "react";
import { Helmet } from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} | Transcending Afritainment </title>
                    <meta name="description" content="Infinity Comics is a media service provider and production company that offers multifarious online streaming content with African niche. The  wide range of content includes a library of films and television programs." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
